<div class="d-flex flex-row" style="height: 100vh">
  <div>
    <app-dashboard-side-menu></app-dashboard-side-menu>
  </div>
  <div class="p-content d-flex flex-column">
    <app-dashboard-top-menu></app-dashboard-top-menu>
    <!-- !!Content to be displayed when loading is complete -->
    @if (loading) {
      <div class="loading-animation">
        <app-loading></app-loading>
      </div>
    } @else {
      <div class="template-content">
        <div class="w-100 d-flex flex-column justify-content-start">
          <div class="d-flex">
            <h2>Importação de registos</h2>
          </div>
          <div class="d-flex flex-column justify-content-between">
            <form>
              <div style="max-width: 440px;">
                <p>Registo @if (isMandatory) {
                  <span>* Obrigatório.</span>
                }</p>
                <mat-form-field class="w-100">
                  <input matInput name="inputRegisto" [(ngModel)]="inputRegisto">
                </mat-form-field>
              </div>
              <div class="mt-3" style="width: 440px;">
                <label class="form-control checkbox-label">
                  <input type="checkbox" name="checkbox" (change)="statusChanged($event)" />
                  <span class="pl-1">Registos atualizados Bio 2</span>
                </label>
              </div>
              <button class="btn-processar mt-4" (click)="processar()" [disabled]="loading">
                <span>Processar</span>
                <img src="../../../../assets/Icons/check-line.png" alt="Check">
              </button>
            </form>
            <!--*REGISTOS IMPORTADOS-->
            @if (!loading && data) {
              @if (data.length > 0 && data[0].statusCode === 200) {
                <div>
                  <h2 class="mt-4">Resultado:</h2>
                  <div class="response-container">
                    @for (registo of data; track registo) {
                      <div class="file-container">
                        <div class="file-info">
                          <p>Registo #{{registo.counter}} | {{registo.registo}}
                            @if (registo.message) {
                              <span style="color: var(--blue-800)"
                              > | {{registo.message}}</span>
                            }
                          </p>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            }
          </div>
        </div>
      </div>
    }
    <app-footer></app-footer>
  </div>
</div>